<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nQLmnn/tc-custom/9781452126210.jpg?1729185361688" alt="This image is the cover for the book Cat Getting Out of a Bag and Other Observations"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cat Getting Out of a Bag and Other Observations
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The celebrated comic artist and graphic novelist explores the unique joys of living with a cat in this delightful collection.</b><br/><br/> Featured in <i>McSweeney’s</i> and on NPR’s <i>This American Life</i>, Jeffrey Brown’s work has always paid tribute to felines as they curl up on couches and purr on the peripheries of his autobiographical stories. <i>Cat Getting Out of a Bag</i> follows his cat Misty—really, any cat—as she goes about her everyday activities and adventures. In a series of drawings, Brown perfectly captures the universal charm of cats in a lovely book sure to please fans and cat lovers of any stripe.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeffrey Brown
      </h2>
      
      <p class="authorDescription body article">Jeffrey Brown has written and illustrated numerous graphic novels and comics, and his work has been widely anthologized. He lives in Chicago.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1895336a